import { openBlock as ie, createElementBlock as ae, createElementVNode as te, toDisplayString as se, Fragment as Pe, renderList as Ae, isProxy as Oe, toRaw as Se, h as ee, ref as je } from "vue";
var ye = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, ce = { exports: {} }, ue = { exports: {} };
/*! For license information please see mgnl-service.min.js.LICENSE.txt */
var me;
function Ce() {
  return me || (me = 1, function(p, V) {
    (function(U, B) {
      p.exports = B();
    })(ye, () => (() => {
      var U = { 61: (a, u, i) => {
        var f = i(698).default;
        function E() {
          a.exports = E = function() {
            return l;
          }, a.exports.__esModule = !0, a.exports.default = a.exports;
          var l = {}, O = Object.prototype, m = O.hasOwnProperty, j = Object.defineProperty || function(r, e, t) {
            r[e] = t.value;
          }, g = typeof Symbol == "function" ? Symbol : {}, L = g.iterator || "@@iterator", b = g.asyncIterator || "@@asyncIterator", v = g.toStringTag || "@@toStringTag";
          function c(r, e, t) {
            return Object.defineProperty(r, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }), r[e];
          }
          try {
            c({}, "");
          } catch {
            c = function(e, t, n) {
              return e[t] = n;
            };
          }
          function y(r, e, t, n) {
            var o = e && e.prototype instanceof D ? e : D, s = Object.create(o.prototype), d = new k(n || []);
            return j(s, "_invoke", { value: C(r, t, d) }), s;
          }
          function _(r, e, t) {
            try {
              return { type: "normal", arg: r.call(e, t) };
            } catch (n) {
              return { type: "throw", arg: n };
            }
          }
          l.wrap = y;
          var P = {};
          function D() {
          }
          function W() {
          }
          function N() {
          }
          var J = {};
          c(J, L, function() {
            return this;
          });
          var $ = Object.getPrototypeOf, K = $ && $($(Q([])));
          K && K !== O && m.call(K, L) && (J = K);
          var h = N.prototype = D.prototype = Object.create(J);
          function T(r) {
            ["next", "throw", "return"].forEach(function(e) {
              c(r, e, function(t) {
                return this._invoke(e, t);
              });
            });
          }
          function w(r, e) {
            function t(o, s, d, S) {
              var A = _(r[o], r, s);
              if (A.type !== "throw") {
                var I = A.arg, R = I.value;
                return R && f(R) == "object" && m.call(R, "__await") ? e.resolve(R.__await).then(function(x) {
                  t("next", x, d, S);
                }, function(x) {
                  t("throw", x, d, S);
                }) : e.resolve(R).then(function(x) {
                  I.value = x, d(I);
                }, function(x) {
                  return t("throw", x, d, S);
                });
              }
              S(A.arg);
            }
            var n;
            j(this, "_invoke", { value: function(o, s) {
              function d() {
                return new e(function(S, A) {
                  t(o, s, S, A);
                });
              }
              return n = n ? n.then(d, d) : d();
            } });
          }
          function C(r, e, t) {
            var n = "suspendedStart";
            return function(o, s) {
              if (n === "executing")
                throw new Error("Generator is already running");
              if (n === "completed") {
                if (o === "throw")
                  throw s;
                return { value: void 0, done: !0 };
              }
              for (t.method = o, t.arg = s; ; ) {
                var d = t.delegate;
                if (d) {
                  var S = F(d, t);
                  if (S) {
                    if (S === P)
                      continue;
                    return S;
                  }
                }
                if (t.method === "next")
                  t.sent = t._sent = t.arg;
                else if (t.method === "throw") {
                  if (n === "suspendedStart")
                    throw n = "completed", t.arg;
                  t.dispatchException(t.arg);
                } else
                  t.method === "return" && t.abrupt("return", t.arg);
                n = "executing";
                var A = _(r, e, t);
                if (A.type === "normal") {
                  if (n = t.done ? "completed" : "suspendedYield", A.arg === P)
                    continue;
                  return { value: A.arg, done: t.done };
                }
                A.type === "throw" && (n = "completed", t.method = "throw", t.arg = A.arg);
              }
            };
          }
          function F(r, e) {
            var t = e.method, n = r.iterator[t];
            if (n === void 0)
              return e.delegate = null, t === "throw" && r.iterator.return && (e.method = "return", e.arg = void 0, F(r, e), e.method === "throw") || t !== "return" && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + t + "' method")), P;
            var o = _(n, r.iterator, e.arg);
            if (o.type === "throw")
              return e.method = "throw", e.arg = o.arg, e.delegate = null, P;
            var s = o.arg;
            return s ? s.done ? (e[r.resultName] = s.value, e.next = r.nextLoc, e.method !== "return" && (e.method = "next", e.arg = void 0), e.delegate = null, P) : s : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, P);
          }
          function G(r) {
            var e = { tryLoc: r[0] };
            1 in r && (e.catchLoc = r[1]), 2 in r && (e.finallyLoc = r[2], e.afterLoc = r[3]), this.tryEntries.push(e);
          }
          function H(r) {
            var e = r.completion || {};
            e.type = "normal", delete e.arg, r.completion = e;
          }
          function k(r) {
            this.tryEntries = [{ tryLoc: "root" }], r.forEach(G, this), this.reset(!0);
          }
          function Q(r) {
            if (r) {
              var e = r[L];
              if (e)
                return e.call(r);
              if (typeof r.next == "function")
                return r;
              if (!isNaN(r.length)) {
                var t = -1, n = function o() {
                  for (; ++t < r.length; )
                    if (m.call(r, t))
                      return o.value = r[t], o.done = !1, o;
                  return o.value = void 0, o.done = !0, o;
                };
                return n.next = n;
              }
            }
            return { next: Z };
          }
          function Z() {
            return { value: void 0, done: !0 };
          }
          return W.prototype = N, j(h, "constructor", { value: N, configurable: !0 }), j(N, "constructor", { value: W, configurable: !0 }), W.displayName = c(N, v, "GeneratorFunction"), l.isGeneratorFunction = function(r) {
            var e = typeof r == "function" && r.constructor;
            return !!e && (e === W || (e.displayName || e.name) === "GeneratorFunction");
          }, l.mark = function(r) {
            return Object.setPrototypeOf ? Object.setPrototypeOf(r, N) : (r.__proto__ = N, c(r, v, "GeneratorFunction")), r.prototype = Object.create(h), r;
          }, l.awrap = function(r) {
            return { __await: r };
          }, T(w.prototype), c(w.prototype, b, function() {
            return this;
          }), l.AsyncIterator = w, l.async = function(r, e, t, n, o) {
            o === void 0 && (o = Promise);
            var s = new w(y(r, e, t, n), o);
            return l.isGeneratorFunction(e) ? s : s.next().then(function(d) {
              return d.done ? d.value : s.next();
            });
          }, T(h), c(h, v, "Generator"), c(h, L, function() {
            return this;
          }), c(h, "toString", function() {
            return "[object Generator]";
          }), l.keys = function(r) {
            var e = Object(r), t = [];
            for (var n in e)
              t.push(n);
            return t.reverse(), function o() {
              for (; t.length; ) {
                var s = t.pop();
                if (s in e)
                  return o.value = s, o.done = !1, o;
              }
              return o.done = !0, o;
            };
          }, l.values = Q, k.prototype = { constructor: k, reset: function(r) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(H), !r)
              for (var e in this)
                e.charAt(0) === "t" && m.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
          }, stop: function() {
            this.done = !0;
            var r = this.tryEntries[0].completion;
            if (r.type === "throw")
              throw r.arg;
            return this.rval;
          }, dispatchException: function(r) {
            if (this.done)
              throw r;
            var e = this;
            function t(A, I) {
              return s.type = "throw", s.arg = r, e.next = A, I && (e.method = "next", e.arg = void 0), !!I;
            }
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n], s = o.completion;
              if (o.tryLoc === "root")
                return t("end");
              if (o.tryLoc <= this.prev) {
                var d = m.call(o, "catchLoc"), S = m.call(o, "finallyLoc");
                if (d && S) {
                  if (this.prev < o.catchLoc)
                    return t(o.catchLoc, !0);
                  if (this.prev < o.finallyLoc)
                    return t(o.finallyLoc);
                } else if (d) {
                  if (this.prev < o.catchLoc)
                    return t(o.catchLoc, !0);
                } else {
                  if (!S)
                    throw new Error("try statement without catch or finally");
                  if (this.prev < o.finallyLoc)
                    return t(o.finallyLoc);
                }
              }
            }
          }, abrupt: function(r, e) {
            for (var t = this.tryEntries.length - 1; t >= 0; --t) {
              var n = this.tryEntries[t];
              if (n.tryLoc <= this.prev && m.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
                var o = n;
                break;
              }
            }
            o && (r === "break" || r === "continue") && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
            var s = o ? o.completion : {};
            return s.type = r, s.arg = e, o ? (this.method = "next", this.next = o.finallyLoc, P) : this.complete(s);
          }, complete: function(r, e) {
            if (r.type === "throw")
              throw r.arg;
            return r.type === "break" || r.type === "continue" ? this.next = r.arg : r.type === "return" ? (this.rval = this.arg = r.arg, this.method = "return", this.next = "end") : r.type === "normal" && e && (this.next = e), P;
          }, finish: function(r) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var t = this.tryEntries[e];
              if (t.finallyLoc === r)
                return this.complete(t.completion, t.afterLoc), H(t), P;
            }
          }, catch: function(r) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var t = this.tryEntries[e];
              if (t.tryLoc === r) {
                var n = t.completion;
                if (n.type === "throw") {
                  var o = n.arg;
                  H(t);
                }
                return o;
              }
            }
            throw new Error("illegal catch attempt");
          }, delegateYield: function(r, e, t) {
            return this.delegate = { iterator: Q(r), resultName: e, nextLoc: t }, this.method === "next" && (this.arg = void 0), P;
          } }, l;
        }
        a.exports = E, a.exports.__esModule = !0, a.exports.default = a.exports;
      }, 698: (a) => {
        function u(i) {
          return a.exports = u = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(f) {
            return typeof f;
          } : function(f) {
            return f && typeof Symbol == "function" && f.constructor === Symbol && f !== Symbol.prototype ? "symbol" : typeof f;
          }, a.exports.__esModule = !0, a.exports.default = a.exports, u(i);
        }
        a.exports = u, a.exports.__esModule = !0, a.exports.default = a.exports;
      }, 687: (a, u, i) => {
        var f = i(61)();
        a.exports = f;
        try {
          regeneratorRuntime = f;
        } catch {
          typeof globalThis == "object" ? globalThis.regeneratorRuntime = f : Function("r", "regeneratorRuntime = r")(f);
        }
      } }, B = {};
      function M(a) {
        var u = B[a];
        if (u !== void 0)
          return u.exports;
        var i = B[a] = { exports: {} };
        return U[a](i, i.exports, M), i.exports;
      }
      M.n = (a) => {
        var u = a && a.__esModule ? () => a.default : () => a;
        return M.d(u, { a: u }), u;
      }, M.d = (a, u) => {
        for (var i in u)
          M.o(u, i) && !M.o(a, i) && Object.defineProperty(a, i, { enumerable: !0, get: u[i] });
      }, M.o = (a, u) => Object.prototype.hasOwnProperty.call(a, u), M.r = (a) => {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(a, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(a, "__esModule", { value: !0 });
      };
      var X = {};
      return (() => {
        function a(r) {
          return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
            return typeof e;
          } : function(e) {
            return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, a(r);
        }
        function u(r, e) {
          (e == null || e > r.length) && (e = r.length);
          for (var t = 0, n = new Array(e); t < e; t++)
            n[t] = r[t];
          return n;
        }
        function i(r, e) {
          return function(t) {
            if (Array.isArray(t))
              return t;
          }(r) || function(t, n) {
            var o = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
            if (o != null) {
              var s, d, S, A, I = [], R = !0, x = !1;
              try {
                if (S = (o = o.call(t)).next, n === 0) {
                  if (Object(o) !== o)
                    return;
                  R = !1;
                } else
                  for (; !(R = (s = S.call(o)).done) && (I.push(s.value), I.length !== n); R = !0)
                    ;
              } catch (Y) {
                x = !0, d = Y;
              } finally {
                try {
                  if (!R && o.return != null && (A = o.return(), Object(A) !== A))
                    return;
                } finally {
                  if (x)
                    throw d;
                }
              }
              return I;
            }
          }(r, e) || function(t, n) {
            if (t) {
              if (typeof t == "string")
                return u(t, n);
              var o = Object.prototype.toString.call(t).slice(8, -1);
              return o === "Object" && t.constructor && (o = t.constructor.name), o === "Map" || o === "Set" ? Array.from(t) : o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? u(t, n) : void 0;
            }
          }(r, e) || function() {
            throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }();
        }
        M.r(X), M.d(X, { EditorContextHelper: () => h, LoggerService: () => w, PageEditorBridge: () => Z, PersonalizationService: () => H, TemplateAnnotations: () => g });
        var f = { content: function(r, e) {
          var t = r ? r[e] : null;
          return t != null ? "website:".concat(t) : "";
        }, availableComponents: function(r, e, t) {
          return t && t[e] ? Object.keys(t[e]).map(function(n) {
            return t[e][n].id;
          }).join(",") : "";
        }, showAddButton: function(r, e, t, n) {
          return !t || t.maxComponents == null || !n || n.componentCount == null || n.componentCount < t.maxComponents;
        }, activationStatus: function(r) {
          if (!r || !r["mgnl:activationStatus"] || r["mgnl:activationStatus"] === "false")
            return 0;
          var e = r["mgnl:lastModified"] ? new Date(r["mgnl:lastModified"]) : null, t = r["mgnl:lastActivated"] ? new Date(r["mgnl:lastActivated"]) : null;
          return e && t && e.getTime() > t.getTime() ? 1 : 2;
        } }, E = { content: ["@path", ""], dialog: ["dialog", "", j] }, l = { name: ["@name", ""], content: E.content, dialog: E.dialog, availableComponents: ["availableComponents", []], type: ["type", "list", j], label: ["title", "", j], inherit: ["inheritance", !1, j], optional: ["optional", !1, j], createdAreaNode: ["createAreaNode", !0, j], showAddButton: ["maxComponents", !0], showNewComponentArea: [null, !0], description: ["description", "", j], activationStatus: [null, 0] }, O = { content: E.content, dialog: E.dialog, label: ["title", "", j], description: ["description", "", j], activationStatus: [null, 0] };
        function m(r, e, t, n) {
          var o = [];
          return Object.keys(e).forEach(function(s) {
            var d = i(e[s], 3), S = d[0], A = d[1], I = d[2], R = f[s], x = A;
            R ? x = R(r, S, t, n) : I ? x = I(t, S, A) : r != null && S !== null && (x = r[S] || "");
            var Y = { key: s, value: x };
            (typeof Y.value != "string" || Y.value) && o.push("".concat(s, '="').concat(Y.value, '"'));
          }), o.join(" ");
        }
        function j(r, e, t) {
          var n = r && a(r) === "object" && e ? r[e] : null;
          return n = n ?? t, (n = typeof t == "boolean" ? !!n : n) != null ? n : t;
        }
        const g = { getAreaCommentString: function(r, e, t) {
          var n = { componentCount: t }, o = e && e.areas ? e.areas[r["@name"]] : {};
          return "cms:area ".concat(m(r, l, o, n));
        }, getComponentCommentString: function(r, e) {
          return "cms:component ".concat(m(r, O, e));
        }, getPageCommentString: function(r, e) {
          return "cms:page ".concat(m(r, E, e));
        }, generateMissingAreas: function(r, e) {
          if (!r || !e)
            return r;
          var t = JSON.parse(JSON.stringify(r));
          return Object.keys(e).forEach(function(n) {
            if (n.includes(r == null ? void 0 : r["@path"]) && e[n].startsWith("cms:area")) {
              var o = n.split("/").pop();
              o in r || (t[o] = { "@path": "".concat(r == null ? void 0 : r["@path"], "/").concat(o), "@nodes": [], "@id": "".concat(r == null ? void 0 : r["@path"], "/").concat(o) });
            }
          }), t;
        } };
        function L(r, e, t, n, o, s, d) {
          try {
            var S = r[s](d), A = S.value;
          } catch (I) {
            return void t(I);
          }
          S.done ? e(A) : Promise.resolve(A).then(n, o);
        }
        function b(r) {
          return function() {
            var e = this, t = arguments;
            return new Promise(function(n, o) {
              var s = r.apply(e, t);
              function d(A) {
                L(s, n, o, d, S, "next", A);
              }
              function S(A) {
                L(s, n, o, d, S, "throw", A);
              }
              d(void 0);
            });
          };
        }
        var v = M(687), c = M.n(v), y = function() {
          try {
            return window.parent.location.href != null;
          } catch {
            return !1;
          }
        };
        function _() {
          if (typeof window < "u")
            return y() ? window.parent : window;
        }
        var P = { serverUrl: y() && typeof window < "u" ? _().location.href : "" }, D = function(r) {
          return new Promise(function(e) {
            setTimeout(e, r);
          });
        }, W = function() {
          var r = b(c().mark(function e(t) {
            return c().wrap(function(n) {
              for (; ; )
                switch (n.prev = n.next) {
                  case 0:
                    if (t()) {
                      n.next = 5;
                      break;
                    }
                    return n.next = 3, D(200);
                  case 3:
                    n.next = 0;
                    break;
                  case 5:
                    return n.abrupt("return", t());
                  case 6:
                  case "end":
                    return n.stop();
                }
            }, e);
          }));
          return function(e) {
            return r.apply(this, arguments);
          };
        }(), N = function() {
          return P.serverUrl.endsWith(":edit");
        }, J = null, $ = function(r) {
          J && clearTimeout(J), J = setTimeout(K, r);
        }, K = function() {
          var r = _();
          r.mgnlRefresh && (document.documentElement.innerHTML.indexOf("cms:page content=") > -1 ? r.mgnlRefresh() : $(200));
        };
        const h = { inEditor: N, inEditorAsync: function() {
          var r = b(c().mark(function e() {
            return c().wrap(function(t) {
              for (; ; )
                switch (t.prev = t.next) {
                  case 0:
                    return t.next = 2, W(function() {
                      return P.serverUrl.length > 0;
                    });
                  case 2:
                    if (!t.sent) {
                      t.next = 4;
                      break;
                    }
                    return t.abrupt("return", P.serverUrl.endsWith(":edit"));
                  case 4:
                    return t.abrupt("return", !1);
                  case 5:
                  case "end":
                    return t.stop();
                }
            }, e);
          }));
          return function() {
            return r.apply(this, arguments);
          };
        }(), inEditorPreview: function() {
          return P.serverUrl.endsWith(":view");
        }, inIframe: function() {
          return typeof window < "u" && window !== window.parent;
        }, isRenderingAnnotation: function() {
          return N() || !P.serverUrl;
        }, isSameOrigin: y, refresh: $, setServerUrl: function(r) {
          P.serverUrl = r;
        }, isPageEditorReady: function() {
          return _().mgnlFrameReady !== void 0;
        }, onFrameReady: function() {
          var r = _();
          r.mgnlFrameReady && r.mgnlFrameReady();
        }, inPreviewAsVisitor: function() {
          var r = _();
          return new URLSearchParams(r.location.search).get("mgnlPreviewAsVisitor") === "true";
        }, getMagnoliaContext: function(r, e, t) {
          var n = function(x) {
            try {
              var Y = /^http(s?):\/\//i.test(x) ? x : "http://valid-url.com" + (x.startsWith("/") ? x : "/" + x);
              return new URL(Y);
            } catch {
              return console.warn("requestUrl is not a valid URL"), !1;
            }
          }(r), o = { isMagnolia: !1, isMagnoliaEdit: !1, isMagnoliaPreview: !1, version: void 0, nodePath: void 0, currentLanguage: void 0, searchParams: void 0, search: void 0 };
          if (n) {
            var s = n.pathname, d = new URLSearchParams(n.search), S = d.get("mgnlPreview"), A = d.get("mgnlPreviewAsVisitor"), I = d.get("mgnlVersion"), R = S ?? A;
            R && (o.isMagnolia = !0, R === "false" && (o.isMagnoliaEdit = !0), R === "true" && (o.isMagnoliaPreview = !0)), o.isMagnolia && !A && d.set("variants", "all"), I ? (o.version = I, d.set("version", I)) : delete o.version, t && (o.currentLanguage = t[0], t.some(function(x) {
              return !!new RegExp("/" + x + "($|/)").test(s) && (o.currentLanguage = x, !0);
            }), d.set("lang", o.currentLanguage)), e && (o.nodePath = e + s.replace(new RegExp("(.*" + e + "|.html|/$)", "g"), ""), o.currentLanguage && (o.nodePath = o.nodePath.replace(new RegExp("/" + o.currentLanguage + "($|/)"), "/")), o.nodePath.slice(-1) === "/" && (o.nodePath = o.nodePath.slice(0, -1))), o.searchParams = Object.fromEntries(d), o.search = "?" + d.toString();
          }
          return o;
        } };
        function T() {
          var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "log", e = arguments.length > 1 ? arguments[1] : void 0;
          if (typeof console < "u") {
            for (var t = arguments.length, n = new Array(t > 2 ? t - 2 : 0), o = 2; o < t; o++)
              n[o - 2] = arguments[o];
            console[r](e, n);
          }
        }
        const w = { log: function(r) {
          for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)
            t[n - 1] = arguments[n];
          T("log", r, t);
        }, info: function(r) {
          for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)
            t[n - 1] = arguments[n];
          T("info", r, t);
        }, warn: function(r) {
          for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)
            t[n - 1] = arguments[n];
          T("warn", r, t);
        }, error: function(r) {
          for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)
            t[n - 1] = arguments[n];
          T("error", r, t);
        } };
        function C(r, e, t) {
          return (e = function(n) {
            var o = function(s, d) {
              if (a(s) !== "object" || s === null)
                return s;
              var S = s[Symbol.toPrimitive];
              if (S !== void 0) {
                var A = S.call(s, "string");
                if (a(A) !== "object")
                  return A;
                throw new TypeError("@@toPrimitive must return a primitive value.");
              }
              return String(s);
            }(n);
            return a(o) === "symbol" ? o : String(o);
          }(e)) in r ? Object.defineProperty(r, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : r[e] = t, r;
        }
        function F(r, e) {
          var t = Object.keys(r);
          if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(r);
            e && (n = n.filter(function(o) {
              return Object.getOwnPropertyDescriptor(r, o).enumerable;
            })), t.push.apply(t, n);
          }
          return t;
        }
        function G(r) {
          for (var e = 1; e < arguments.length; e++) {
            var t = arguments[e] != null ? arguments[e] : {};
            e % 2 ? F(Object(t), !0).forEach(function(n) {
              C(r, n, t[n]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : F(Object(t)).forEach(function(n) {
              Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
            });
          }
          return r;
        }
        const H = { getVariant: function(r, e) {
          return !h.inIframe() || h.inPreviewAsVisitor() ? r : function(t, n) {
            if (!t || !n)
              return t;
            var o = n[t == null ? void 0 : t["@path"]], s = o ? o.match(/selectedVariant="(.+)"/) : null;
            if (!s)
              return t;
            var d = s[1];
            return d === t["@name"] ? t : t[d];
          }(r, e);
        }, wrap: function(r, e) {
          if (!e)
            return r;
          var t = {}, n = /selectedVariant="(.+?)"/, o = /content="(.+?)"/, s = /((variants|variantTitles)=".+?")/g;
          return Object.entries(r).forEach(function(d) {
            var S = i(d, 2), A = S[0], I = S[1];
            if (n.test(I) && A in e) {
              var R = e[A];
              if (R === "original")
                R = A.split("/").pop(), t[A] = I.replace(n, 'selectedVariant="'.concat(R, '"'));
              else {
                var x = A + "/variants/" + R, Y = r[x];
                Y != null ? (t[A] = Y.replace(o, I.match(o)[0]), t[A] = t[A].concat(" ", I.match(s).join(" ")), t[A] = t[A].concat(" ", 'selectedVariant="'.concat(R, '"'))) : w.warn("Cannot find the variant with path '%s'. Please review the document https://docs.magnolia-cms.com/headless/spa-development/personalization-of-headless-SPA-projects.html#_notes.", x);
              }
            }
          }), G(G({}, r), t);
        } };
        var k = function(r, e, t) {
          if (e && typeof t == "function") {
            var n = e.toLowerCase();
            r[n] = r[n] || [], r[n].push(t);
          }
        }, Q = function() {
          window.parent.postMessage(JSON.stringify({ element: { dialog: "", path: "/", workspace: "website" }, action: "initialize", elementType: "page" }), "*");
        };
        const Z = { init: function(r, e) {
          typeof window > "u" || h.isSameOrigin() || (window.addEventListener("message", function(t) {
            if (t.data && typeof t.data == "string" && t.data.startsWith("{")) {
              var n = JSON.parse(t.data), o = function(s, d) {
                return d && s[d.toLowerCase()] || [];
              }(r, n.action);
              o.forEach(function(s) {
                try {
                  s(n);
                } catch (d) {
                  console.error(d);
                }
              });
            }
          }), k(r, "updateState", function(t) {
            var n = t.serverUrl;
            h.setServerUrl(n), function(o, s) {
              var d = "mgnlPageEditorBridge", S = document.getElementById(d);
              if (!S && s) {
                var A = function(x) {
                  var Y = new URL(x);
                  return "".concat(Y.protocol, "//").concat(Y.hostname).concat(Y.port ? ":".concat(Y.port) : "").concat(Y.pathname.substring(0, Y.pathname.indexOf(".magnolia")));
                }(s), I = document.getElementsByTagName("script")[0];
                (S = document.createElement("script")).id = d, S.src = "".concat(A, "VAADIN/widgetsets/info.magnolia.PageEditor/info.magnolia.PageEditor.nocache.js"), I.parentNode.insertBefore(S, I), S.onload = function() {
                  setTimeout(function x() {
                    h.isPageEditorReady() ? (h.onFrameReady(), h.refresh(), typeof o == "function" && o()) : setTimeout(x, 100);
                  }, 50);
                };
                var R = document.createElement("link");
                R.href = "".concat(A, "VAADIN/themes/pages-app/page-editor.css"), R.type = "text/css", R.rel = "stylesheet", document.head.insertBefore(R, document.head.firstChild);
              } else
                typeof o == "function" && o();
            }(e, n);
          }), Q());
        }, onMessage: k, requestServerUrl: Q };
      })(), X;
    })());
  }(ue)), ue.exports;
}
var le = { exports: {} }, ve;
function Te() {
  return ve || (ve = 1, function(p, V) {
    (function(B, M) {
      p.exports = M();
    })(ye, () => (
      /******/
      (() => {
        var U = {
          /***/
          "./src/service/EditorContextHelper.js": (
            /*!********************************************!*\
              !*** ./src/service/EditorContextHelper.js ***!
              \********************************************/
            /***/
            (a, u, i) => {
              i.r(u), i.d(u, {
                /* harmony export */
                default: () => T,
                /* harmony export */
                inEditor: () => (
                  /* binding */
                  y
                ),
                /* harmony export */
                inEditorAsync: () => (
                  /* binding */
                  _
                ),
                /* harmony export */
                inEditorPreview: () => (
                  /* binding */
                  P
                ),
                /* harmony export */
                inIframe: () => (
                  /* binding */
                  v
                ),
                /* harmony export */
                inPreviewAsVisitor: () => (
                  /* binding */
                  c
                ),
                /* harmony export */
                isPageEditorReady: () => (
                  /* binding */
                  $
                ),
                /* harmony export */
                isRenderingAnnotation: () => (
                  /* binding */
                  D
                ),
                /* harmony export */
                isSameOrigin: () => (
                  /* binding */
                  m
                ),
                /* harmony export */
                onFrameReady: () => (
                  /* binding */
                  K
                ),
                /* harmony export */
                refresh: () => (
                  /* binding */
                  N
                ),
                /* harmony export */
                setServerUrl: () => (
                  /* binding */
                  h
                )
                /* harmony export */
              });
              var f = i(
                /*! @babel/runtime/helpers/asyncToGenerator */
                "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"
              ), E = i(
                /*! @babel/runtime/regenerator */
                "./node_modules/@babel/runtime/regenerator/index.js"
              ), l = /* @__PURE__ */ i.n(E), O = i(
                /*! ./GetMagnoliaContext */
                "./src/service/GetMagnoliaContext.js"
              ), m = function() {
                try {
                  var C = window.parent.location.href;
                  return C != null;
                } catch {
                  return !1;
                }
              };
              function j() {
                if (!(typeof window > "u"))
                  return m() ? window.parent : window;
              }
              var g = {
                serverUrl: m() && typeof window < "u" ? j().location.href : ""
              }, L = function(C) {
                return new Promise(function(F) {
                  setTimeout(F, C);
                });
              }, b = /* @__PURE__ */ function() {
                var w = (0, f.default)(/* @__PURE__ */ l().mark(function C(F) {
                  return l().wrap(function(H) {
                    for (; ; )
                      switch (H.prev = H.next) {
                        case 0:
                          if (F()) {
                            H.next = 5;
                            break;
                          }
                          return H.next = 3, L(200);
                        case 3:
                          H.next = 0;
                          break;
                        case 5:
                          return H.abrupt("return", F());
                        case 6:
                        case "end":
                          return H.stop();
                      }
                  }, C);
                }));
                return function(F) {
                  return w.apply(this, arguments);
                };
              }(), v = function() {
                return typeof window < "u" ? window !== window.parent : !1;
              }, c = function() {
                var C = j();
                return new URLSearchParams(C.location.search).get("mgnlPreviewAsVisitor") === "true";
              }, y = function() {
                return g.serverUrl.endsWith(":edit");
              }, _ = /* @__PURE__ */ function() {
                var w = (0, f.default)(/* @__PURE__ */ l().mark(function C() {
                  return l().wrap(function(G) {
                    for (; ; )
                      switch (G.prev = G.next) {
                        case 0:
                          return G.next = 2, b(function() {
                            return g.serverUrl.length > 0;
                          });
                        case 2:
                          if (!G.sent) {
                            G.next = 4;
                            break;
                          }
                          return G.abrupt("return", g.serverUrl.endsWith(":edit"));
                        case 4:
                          return G.abrupt("return", !1);
                        case 5:
                        case "end":
                          return G.stop();
                      }
                  }, C);
                }));
                return function() {
                  return w.apply(this, arguments);
                };
              }(), P = function() {
                return g.serverUrl.endsWith(":view");
              }, D = function() {
                return y() || !g.serverUrl;
              }, W = null, N = function(C) {
                W && clearTimeout(W), W = setTimeout(J, C);
              }, J = function() {
                var C = j();
                C.mgnlRefresh && (document.documentElement.innerHTML.indexOf("cms:page content=") > -1 ? C.mgnlRefresh() : N(200));
              }, $ = function() {
                var C = j();
                return C.mgnlFrameReady !== void 0;
              }, K = function() {
                var C = j();
                C.mgnlFrameReady && C.mgnlFrameReady();
              }, h = function(C) {
                g.serverUrl = C;
              };
              const T = {
                inEditor: y,
                inEditorAsync: _,
                inEditorPreview: P,
                inIframe: v,
                isRenderingAnnotation: D,
                isSameOrigin: m,
                refresh: N,
                setServerUrl: h,
                isPageEditorReady: $,
                onFrameReady: K,
                inPreviewAsVisitor: c,
                getMagnoliaContext: O.default
              };
            }
          ),
          /***/
          "./src/service/GetMagnoliaContext.js": (
            /*!*******************************************!*\
              !*** ./src/service/GetMagnoliaContext.js ***!
              \*******************************************/
            /***/
            (a, u, i) => {
              i.r(u), i.d(u, {
                /* harmony export */
                default: () => (
                  /* binding */
                  E
                )
                /* harmony export */
              });
              function f(l) {
                try {
                  var O = /^http(s?):\/\//i.test(l) ? l : "http://valid-url.com" + (l.startsWith("/") ? l : "/" + l);
                  return new URL(O);
                } catch {
                  return console.warn("requestUrl is not a valid URL"), !1;
                }
              }
              function E(l, O, m) {
                var j = f(l), g = {
                  isMagnolia: !1,
                  isMagnoliaEdit: !1,
                  isMagnoliaPreview: !1,
                  version: void 0,
                  nodePath: void 0,
                  currentLanguage: void 0,
                  searchParams: void 0,
                  search: void 0
                };
                if (j) {
                  var L = j.pathname, b = new URLSearchParams(j.search), v = b.get("mgnlPreview"), c = b.get("mgnlPreviewAsVisitor"), y = b.get("mgnlVersion"), _ = v ?? c;
                  _ && (g.isMagnolia = !0, _ === "false" && (g.isMagnoliaEdit = !0), _ === "true" && (g.isMagnoliaPreview = !0)), g.isMagnolia && !c && b.set("variants", "all"), y ? (g.version = y, b.set("version", y)) : delete g.version, m && (g.currentLanguage = m[0], m.some(function(P) {
                    return new RegExp("/" + P + "($|/)").test(L) ? (g.currentLanguage = P, !0) : !1;
                  }), b.set("lang", g.currentLanguage)), O && (g.nodePath = O + L.replace(new RegExp("(.*" + O + "|.html|/$)", "g"), ""), g.currentLanguage && (g.nodePath = g.nodePath.replace(new RegExp("/" + g.currentLanguage + "($|/)"), "/")), g.nodePath.slice(-1) === "/" && (g.nodePath = g.nodePath.slice(0, -1))), g.searchParams = Object.fromEntries(b), g.search = "?" + b.toString();
                }
                return g;
              }
            }
          ),
          /***/
          "./src/service/LoggerService.js": (
            /*!**************************************!*\
              !*** ./src/service/LoggerService.js ***!
              \**************************************/
            /***/
            (a, u, i) => {
              i.r(u), i.d(u, {
                /* harmony export */
                default: () => j,
                /* harmony export */
                error: () => (
                  /* binding */
                  m
                ),
                /* harmony export */
                info: () => (
                  /* binding */
                  l
                ),
                /* harmony export */
                log: () => (
                  /* binding */
                  E
                ),
                /* harmony export */
                warn: () => (
                  /* binding */
                  O
                )
                /* harmony export */
              });
              function f() {
                var g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "log", L = arguments.length > 1 ? arguments[1] : void 0;
                if (!(typeof console > "u")) {
                  for (var b = arguments.length, v = new Array(b > 2 ? b - 2 : 0), c = 2; c < b; c++)
                    v[c - 2] = arguments[c];
                  console[g](L, v);
                }
              }
              var E = function(L) {
                for (var b = arguments.length, v = new Array(b > 1 ? b - 1 : 0), c = 1; c < b; c++)
                  v[c - 1] = arguments[c];
                f("log", L, v);
              }, l = function(L) {
                for (var b = arguments.length, v = new Array(b > 1 ? b - 1 : 0), c = 1; c < b; c++)
                  v[c - 1] = arguments[c];
                f("info", L, v);
              }, O = function(L) {
                for (var b = arguments.length, v = new Array(b > 1 ? b - 1 : 0), c = 1; c < b; c++)
                  v[c - 1] = arguments[c];
                f("warn", L, v);
              }, m = function(L) {
                for (var b = arguments.length, v = new Array(b > 1 ? b - 1 : 0), c = 1; c < b; c++)
                  v[c - 1] = arguments[c];
                f("error", L, v);
              };
              const j = {
                log: E,
                info: l,
                warn: O,
                error: m
              };
            }
          ),
          /***/
          "./src/service/PageEditorBridge.js": (
            /*!*****************************************!*\
              !*** ./src/service/PageEditorBridge.js ***!
              \*****************************************/
            /***/
            (a, u, i) => {
              i.r(u), i.d(u, {
                /* harmony export */
                default: () => L,
                /* harmony export */
                getBaseServerUrl: () => (
                  /* binding */
                  l
                ),
                /* harmony export */
                init: () => (
                  /* binding */
                  g
                ),
                /* harmony export */
                onMessage: () => (
                  /* binding */
                  E
                ),
                /* harmony export */
                requestServerUrl: () => (
                  /* binding */
                  j
                )
                /* harmony export */
              });
              var f = i(
                /*! ./EditorContextHelper */
                "./src/service/EditorContextHelper.js"
              ), E = function(v, c, y) {
                if (!(!c || typeof y != "function")) {
                  var _ = c.toLowerCase();
                  v[_] = v[_] || [], v[_].push(y);
                }
              };
              function l(b) {
                var v = new URL(b);
                return "".concat(v.protocol, "//").concat(v.hostname).concat(v.port ? ":".concat(v.port) : "").concat(v.pathname.substring(0, v.pathname.indexOf(".magnolia")));
              }
              function O(b, v) {
                return v ? b[v.toLowerCase()] || [] : [];
              }
              function m(b, v) {
                var c = "mgnlPageEditorBridge", y = document.getElementById(c);
                if (y || !v) {
                  typeof b == "function" && b();
                  return;
                }
                var _ = l(v), P = document.getElementsByTagName("script")[0];
                y = document.createElement("script"), y.id = c, y.src = "".concat(_, "VAADIN/widgetsets/info.magnolia.PageEditor/info.magnolia.PageEditor.nocache.js"), P.parentNode.insertBefore(y, P), y.onload = function() {
                  setTimeout(function W() {
                    f.default.isPageEditorReady() ? (f.default.onFrameReady(), f.default.refresh(), typeof b == "function" && b()) : setTimeout(W, 100);
                  }, 50);
                };
                var D = document.createElement("link");
                D.href = "".concat(_, "VAADIN/themes/pages-app/page-editor.css"), D.type = "text/css", D.rel = "stylesheet", document.head.insertBefore(D, document.head.firstChild);
              }
              var j = function() {
                var v = {
                  element: {
                    dialog: "",
                    path: "/",
                    workspace: "website"
                  },
                  action: "initialize",
                  elementType: "page"
                };
                window.parent.postMessage(JSON.stringify(v), "*");
              }, g = function(v, c) {
                typeof window > "u" || f.default.isSameOrigin() || (window.addEventListener("message", function(y) {
                  if (!(!y.data || !(typeof y.data == "string" && y.data.startsWith("{")))) {
                    var _ = JSON.parse(y.data), P = O(v, _.action);
                    P.forEach(function(D) {
                      try {
                        D(_);
                      } catch (W) {
                        console.error(W);
                      }
                    });
                  }
                }), E(v, "updateState", function(y) {
                  var _ = y.serverUrl;
                  f.default.setServerUrl(_), m(c, _);
                }), j());
              };
              const L = {
                init: g,
                onMessage: E,
                requestServerUrl: j
              };
            }
          ),
          /***/
          "./src/service/PersonalizationService.js": (
            /*!***********************************************!*\
              !*** ./src/service/PersonalizationService.js ***!
              \***********************************************/
            /***/
            (a, u, i) => {
              i.r(u), i.d(u, {
                /* harmony export */
                default: () => v,
                /* harmony export */
                getSelectedVariant: () => (
                  /* binding */
                  g
                ),
                /* harmony export */
                getVariant: () => (
                  /* binding */
                  L
                ),
                /* harmony export */
                wrap: () => (
                  /* binding */
                  b
                )
                /* harmony export */
              });
              var f = i(
                /*! @babel/runtime/helpers/defineProperty */
                "./node_modules/@babel/runtime/helpers/esm/defineProperty.js"
              ), E = i(
                /*! @babel/runtime/helpers/slicedToArray */
                "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js"
              ), l = i(
                /*! ./EditorContextHelper */
                "./src/service/EditorContextHelper.js"
              ), O = i(
                /*! ./LoggerService */
                "./src/service/LoggerService.js"
              );
              function m(c, y) {
                var _ = Object.keys(c);
                if (Object.getOwnPropertySymbols) {
                  var P = Object.getOwnPropertySymbols(c);
                  y && (P = P.filter(function(D) {
                    return Object.getOwnPropertyDescriptor(c, D).enumerable;
                  })), _.push.apply(_, P);
                }
                return _;
              }
              function j(c) {
                for (var y = 1; y < arguments.length; y++) {
                  var _ = arguments[y] != null ? arguments[y] : {};
                  y % 2 ? m(Object(_), !0).forEach(function(P) {
                    (0, f.default)(c, P, _[P]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(c, Object.getOwnPropertyDescriptors(_)) : m(Object(_)).forEach(function(P) {
                    Object.defineProperty(c, P, Object.getOwnPropertyDescriptor(_, P));
                  });
                }
                return c;
              }
              var g = function(y, _) {
                if (!y || !_)
                  return y;
                var P = _[y == null ? void 0 : y["@path"]], D = P ? P.match(/selectedVariant="(.+)"/) : null;
                if (!D)
                  return y;
                var W = D[1];
                return W === y["@name"] ? y : y[W];
              }, L = function(y, _) {
                return !l.default.inIframe() || l.default.inPreviewAsVisitor() ? y : g(y, _);
              }, b = function(y, _) {
                if (!_)
                  return y;
                var P = {}, D = /selectedVariant="(.+?)"/, W = /content="(.+?)"/, N = /((variants|variantTitles)=".+?")/g;
                return Object.entries(y).forEach(function(J) {
                  var $ = (0, E.default)(J, 2), K = $[0], h = $[1];
                  if (D.test(h) && K in _) {
                    var T = _[K];
                    if (T === "original")
                      T = K.split("/").pop(), P[K] = h.replace(D, 'selectedVariant="'.concat(T, '"'));
                    else {
                      var w = K + "/variants/" + T, C = y[w];
                      C != null ? (P[K] = C.replace(W, h.match(W)[0]), P[K] = P[K].concat(" ", h.match(N).join(" ")), P[K] = P[K].concat(" ", 'selectedVariant="'.concat(T, '"'))) : O.default.warn("Cannot find the variant with path '%s'. Please review the document https://docs.magnolia-cms.com/headless/spa-development/personalization-of-headless-SPA-projects.html#_notes.", w);
                    }
                  }
                }), j(j({}, y), P);
              };
              const v = {
                getVariant: L,
                wrap: b
              };
            }
          ),
          /***/
          "./src/service/TemplateAnnotations.js": (
            /*!********************************************!*\
              !*** ./src/service/TemplateAnnotations.js ***!
              \********************************************/
            /***/
            (a, u, i) => {
              i.r(u), i.d(u, {
                /* harmony export */
                default: () => K,
                /* harmony export */
                getAreaCommentString: () => (
                  /* binding */
                  J
                ),
                /* harmony export */
                getComponentCommentString: () => (
                  /* binding */
                  $
                ),
                /* harmony export */
                getPageCommentString: () => (
                  /* binding */
                  N
                )
                /* harmony export */
              });
              var f = i(
                /*! @babel/runtime/helpers/typeof */
                "./node_modules/@babel/runtime/helpers/esm/typeof.js"
              ), E = i(
                /*! @babel/runtime/helpers/slicedToArray */
                "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js"
              ), l = 0, O = 1, m = 2, j = {
                content: P,
                availableComponents: c,
                showAddButton: y,
                activationStatus: W
              }, g = {
                content: ["@path", ""],
                dialog: ["dialog", "", _]
              }, L = {
                name: ["@name", ""],
                content: g.content,
                dialog: g.dialog,
                availableComponents: ["availableComponents", []],
                type: ["type", "list", _],
                label: ["title", "", _],
                inherit: ["inheritance", !1, _],
                optional: ["optional", !1, _],
                createdAreaNode: ["createAreaNode", !0, _],
                showAddButton: ["maxComponents", !0],
                showNewComponentArea: [null, !0],
                description: ["description", "", _],
                activationStatus: [null, 0]
              }, b = {
                content: g.content,
                dialog: g.dialog,
                label: ["title", "", _],
                description: ["description", "", _],
                activationStatus: [null, 0]
              };
              function v(h, T, w, C) {
                var F = [];
                return Object.keys(T).forEach(function(G) {
                  var H = (0, E.default)(T[G], 3), k = H[0], Q = H[1], Z = H[2], r = j[G], e = Q;
                  r ? e = r(h, k, w, C) : Z ? e = Z(w, k, Q) : h != null && k !== null && (e = h[k] || "");
                  var t = {
                    key: G,
                    value: e
                  };
                  (typeof t.value != "string" || t.value) && F.push("".concat(G, '="').concat(t.value, '"'));
                }), F.join(" ");
              }
              function c(h, T, w) {
                return !w || !w[T] ? "" : Object.keys(w[T]).map(function(C) {
                  return w[T][C].id;
                }).join(",");
              }
              function y(h, T, w, C) {
                return !w || w.maxComponents == null || !C || C.componentCount == null ? !0 : C.componentCount < w.maxComponents;
              }
              function _(h, T, w) {
                var C = h && (0, f.default)(h) === "object" && T ? h[T] : null;
                return C = C ?? w, C = typeof w == "boolean" ? !!C : C, C ?? w;
              }
              function P(h, T) {
                var w = h ? h[T] : null;
                return w != null ? "website:".concat(w) : "";
              }
              function D(h, T) {
                if (!h || !T)
                  return h;
                var w = JSON.parse(JSON.stringify(h));
                return Object.keys(T).forEach(function(C) {
                  if (C.includes(h == null ? void 0 : h["@path"]) && T[C].startsWith("cms:area")) {
                    var F = C.split("/").pop();
                    F in h || (w[F] = {
                      "@path": "".concat(h == null ? void 0 : h["@path"], "/").concat(F),
                      "@nodes": [],
                      "@id": "".concat(h == null ? void 0 : h["@path"], "/").concat(F)
                    });
                  }
                }), w;
              }
              function W(h) {
                if (!h || !h["mgnl:activationStatus"] || h["mgnl:activationStatus"] === "false")
                  return l;
                var T = h["mgnl:lastModified"] ? new Date(h["mgnl:lastModified"]) : null, w = h["mgnl:lastActivated"] ? new Date(h["mgnl:lastActivated"]) : null;
                return T && w && T.getTime() > w.getTime() ? O : m;
              }
              var N = function(T, w) {
                return "cms:page ".concat(v(T, g, w));
              }, J = function(T, w, C) {
                var F = {
                  componentCount: C
                }, G = w && w.areas ? w.areas[T["@name"]] : {};
                return "cms:area ".concat(v(T, L, G, F));
              }, $ = function(T, w) {
                return "cms:component ".concat(v(T, b, w));
              };
              const K = {
                getAreaCommentString: J,
                getComponentCommentString: $,
                getPageCommentString: N,
                generateMissingAreas: D
              };
            }
          ),
          /***/
          "./src/service/index.js": (
            /*!******************************!*\
              !*** ./src/service/index.js ***!
              \******************************/
            /***/
            (a, u, i) => {
              i.r(u), i.d(u, {
                /* harmony export */
                EditorContextHelper: () => (
                  /* reexport safe */
                  E.default
                ),
                /* harmony export */
                LoggerService: () => (
                  /* reexport safe */
                  l.default
                ),
                /* harmony export */
                PageEditorBridge: () => (
                  /* reexport safe */
                  m.default
                ),
                /* harmony export */
                PersonalizationService: () => (
                  /* reexport safe */
                  O.default
                ),
                /* harmony export */
                TemplateAnnotations: () => (
                  /* reexport safe */
                  f.default
                )
                /* harmony export */
              });
              var f = i(
                /*! ./TemplateAnnotations */
                "./src/service/TemplateAnnotations.js"
              ), E = i(
                /*! ./EditorContextHelper */
                "./src/service/EditorContextHelper.js"
              ), l = i(
                /*! ./LoggerService */
                "./src/service/LoggerService.js"
              ), O = i(
                /*! ./PersonalizationService */
                "./src/service/PersonalizationService.js"
              ), m = i(
                /*! ./PageEditorBridge */
                "./src/service/PageEditorBridge.js"
              );
            }
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/regeneratorRuntime.js": (
            /*!*******************************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/regeneratorRuntime.js ***!
              \*******************************************************************/
            /***/
            (a, u, i) => {
              var f = i(
                /*! ./typeof.js */
                "./node_modules/@babel/runtime/helpers/typeof.js"
              ).default;
              function E() {
                a.exports = E = function() {
                  return l;
                }, a.exports.__esModule = !0, a.exports.default = a.exports;
                var l = {}, O = Object.prototype, m = O.hasOwnProperty, j = Object.defineProperty || function(r, e, t) {
                  r[e] = t.value;
                }, g = typeof Symbol == "function" ? Symbol : {}, L = g.iterator || "@@iterator", b = g.asyncIterator || "@@asyncIterator", v = g.toStringTag || "@@toStringTag";
                function c(r, e, t) {
                  return Object.defineProperty(r, e, {
                    value: t,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                  }), r[e];
                }
                try {
                  c({}, "");
                } catch {
                  c = function(t, n, o) {
                    return t[n] = o;
                  };
                }
                function y(r, e, t, n) {
                  var o = e && e.prototype instanceof D ? e : D, s = Object.create(o.prototype), d = new k(n || []);
                  return j(s, "_invoke", {
                    value: C(r, t, d)
                  }), s;
                }
                function _(r, e, t) {
                  try {
                    return {
                      type: "normal",
                      arg: r.call(e, t)
                    };
                  } catch (n) {
                    return {
                      type: "throw",
                      arg: n
                    };
                  }
                }
                l.wrap = y;
                var P = {};
                function D() {
                }
                function W() {
                }
                function N() {
                }
                var J = {};
                c(J, L, function() {
                  return this;
                });
                var $ = Object.getPrototypeOf, K = $ && $($(Q([])));
                K && K !== O && m.call(K, L) && (J = K);
                var h = N.prototype = D.prototype = Object.create(J);
                function T(r) {
                  ["next", "throw", "return"].forEach(function(e) {
                    c(r, e, function(t) {
                      return this._invoke(e, t);
                    });
                  });
                }
                function w(r, e) {
                  function t(o, s, d, S) {
                    var A = _(r[o], r, s);
                    if (A.type !== "throw") {
                      var I = A.arg, R = I.value;
                      return R && f(R) == "object" && m.call(R, "__await") ? e.resolve(R.__await).then(function(x) {
                        t("next", x, d, S);
                      }, function(x) {
                        t("throw", x, d, S);
                      }) : e.resolve(R).then(function(x) {
                        I.value = x, d(I);
                      }, function(x) {
                        return t("throw", x, d, S);
                      });
                    }
                    S(A.arg);
                  }
                  var n;
                  j(this, "_invoke", {
                    value: function(s, d) {
                      function S() {
                        return new e(function(A, I) {
                          t(s, d, A, I);
                        });
                      }
                      return n = n ? n.then(S, S) : S();
                    }
                  });
                }
                function C(r, e, t) {
                  var n = "suspendedStart";
                  return function(o, s) {
                    if (n === "executing")
                      throw new Error("Generator is already running");
                    if (n === "completed") {
                      if (o === "throw")
                        throw s;
                      return Z();
                    }
                    for (t.method = o, t.arg = s; ; ) {
                      var d = t.delegate;
                      if (d) {
                        var S = F(d, t);
                        if (S) {
                          if (S === P)
                            continue;
                          return S;
                        }
                      }
                      if (t.method === "next")
                        t.sent = t._sent = t.arg;
                      else if (t.method === "throw") {
                        if (n === "suspendedStart")
                          throw n = "completed", t.arg;
                        t.dispatchException(t.arg);
                      } else
                        t.method === "return" && t.abrupt("return", t.arg);
                      n = "executing";
                      var A = _(r, e, t);
                      if (A.type === "normal") {
                        if (n = t.done ? "completed" : "suspendedYield", A.arg === P)
                          continue;
                        return {
                          value: A.arg,
                          done: t.done
                        };
                      }
                      A.type === "throw" && (n = "completed", t.method = "throw", t.arg = A.arg);
                    }
                  };
                }
                function F(r, e) {
                  var t = e.method, n = r.iterator[t];
                  if (n === void 0)
                    return e.delegate = null, t === "throw" && r.iterator.return && (e.method = "return", e.arg = void 0, F(r, e), e.method === "throw") || t !== "return" && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + t + "' method")), P;
                  var o = _(n, r.iterator, e.arg);
                  if (o.type === "throw")
                    return e.method = "throw", e.arg = o.arg, e.delegate = null, P;
                  var s = o.arg;
                  return s ? s.done ? (e[r.resultName] = s.value, e.next = r.nextLoc, e.method !== "return" && (e.method = "next", e.arg = void 0), e.delegate = null, P) : s : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, P);
                }
                function G(r) {
                  var e = {
                    tryLoc: r[0]
                  };
                  1 in r && (e.catchLoc = r[1]), 2 in r && (e.finallyLoc = r[2], e.afterLoc = r[3]), this.tryEntries.push(e);
                }
                function H(r) {
                  var e = r.completion || {};
                  e.type = "normal", delete e.arg, r.completion = e;
                }
                function k(r) {
                  this.tryEntries = [{
                    tryLoc: "root"
                  }], r.forEach(G, this), this.reset(!0);
                }
                function Q(r) {
                  if (r) {
                    var e = r[L];
                    if (e)
                      return e.call(r);
                    if (typeof r.next == "function")
                      return r;
                    if (!isNaN(r.length)) {
                      var t = -1, n = function o() {
                        for (; ++t < r.length; )
                          if (m.call(r, t))
                            return o.value = r[t], o.done = !1, o;
                        return o.value = void 0, o.done = !0, o;
                      };
                      return n.next = n;
                    }
                  }
                  return {
                    next: Z
                  };
                }
                function Z() {
                  return {
                    value: void 0,
                    done: !0
                  };
                }
                return W.prototype = N, j(h, "constructor", {
                  value: N,
                  configurable: !0
                }), j(N, "constructor", {
                  value: W,
                  configurable: !0
                }), W.displayName = c(N, v, "GeneratorFunction"), l.isGeneratorFunction = function(r) {
                  var e = typeof r == "function" && r.constructor;
                  return !!e && (e === W || (e.displayName || e.name) === "GeneratorFunction");
                }, l.mark = function(r) {
                  return Object.setPrototypeOf ? Object.setPrototypeOf(r, N) : (r.__proto__ = N, c(r, v, "GeneratorFunction")), r.prototype = Object.create(h), r;
                }, l.awrap = function(r) {
                  return {
                    __await: r
                  };
                }, T(w.prototype), c(w.prototype, b, function() {
                  return this;
                }), l.AsyncIterator = w, l.async = function(r, e, t, n, o) {
                  o === void 0 && (o = Promise);
                  var s = new w(y(r, e, t, n), o);
                  return l.isGeneratorFunction(e) ? s : s.next().then(function(d) {
                    return d.done ? d.value : s.next();
                  });
                }, T(h), c(h, v, "Generator"), c(h, L, function() {
                  return this;
                }), c(h, "toString", function() {
                  return "[object Generator]";
                }), l.keys = function(r) {
                  var e = Object(r), t = [];
                  for (var n in e)
                    t.push(n);
                  return t.reverse(), function o() {
                    for (; t.length; ) {
                      var s = t.pop();
                      if (s in e)
                        return o.value = s, o.done = !1, o;
                    }
                    return o.done = !0, o;
                  };
                }, l.values = Q, k.prototype = {
                  constructor: k,
                  reset: function(e) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(H), !e)
                      for (var t in this)
                        t.charAt(0) === "t" && m.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                  },
                  stop: function() {
                    this.done = !0;
                    var e = this.tryEntries[0].completion;
                    if (e.type === "throw")
                      throw e.arg;
                    return this.rval;
                  },
                  dispatchException: function(e) {
                    if (this.done)
                      throw e;
                    var t = this;
                    function n(I, R) {
                      return d.type = "throw", d.arg = e, t.next = I, R && (t.method = "next", t.arg = void 0), !!R;
                    }
                    for (var o = this.tryEntries.length - 1; o >= 0; --o) {
                      var s = this.tryEntries[o], d = s.completion;
                      if (s.tryLoc === "root")
                        return n("end");
                      if (s.tryLoc <= this.prev) {
                        var S = m.call(s, "catchLoc"), A = m.call(s, "finallyLoc");
                        if (S && A) {
                          if (this.prev < s.catchLoc)
                            return n(s.catchLoc, !0);
                          if (this.prev < s.finallyLoc)
                            return n(s.finallyLoc);
                        } else if (S) {
                          if (this.prev < s.catchLoc)
                            return n(s.catchLoc, !0);
                        } else {
                          if (!A)
                            throw new Error("try statement without catch or finally");
                          if (this.prev < s.finallyLoc)
                            return n(s.finallyLoc);
                        }
                      }
                    }
                  },
                  abrupt: function(e, t) {
                    for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                      var o = this.tryEntries[n];
                      if (o.tryLoc <= this.prev && m.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                        var s = o;
                        break;
                      }
                    }
                    s && (e === "break" || e === "continue") && s.tryLoc <= t && t <= s.finallyLoc && (s = null);
                    var d = s ? s.completion : {};
                    return d.type = e, d.arg = t, s ? (this.method = "next", this.next = s.finallyLoc, P) : this.complete(d);
                  },
                  complete: function(e, t) {
                    if (e.type === "throw")
                      throw e.arg;
                    return e.type === "break" || e.type === "continue" ? this.next = e.arg : e.type === "return" ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : e.type === "normal" && t && (this.next = t), P;
                  },
                  finish: function(e) {
                    for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                      var n = this.tryEntries[t];
                      if (n.finallyLoc === e)
                        return this.complete(n.completion, n.afterLoc), H(n), P;
                    }
                  },
                  catch: function(e) {
                    for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                      var n = this.tryEntries[t];
                      if (n.tryLoc === e) {
                        var o = n.completion;
                        if (o.type === "throw") {
                          var s = o.arg;
                          H(n);
                        }
                        return s;
                      }
                    }
                    throw new Error("illegal catch attempt");
                  },
                  delegateYield: function(e, t, n) {
                    return this.delegate = {
                      iterator: Q(e),
                      resultName: t,
                      nextLoc: n
                    }, this.method === "next" && (this.arg = void 0), P;
                  }
                }, l;
              }
              a.exports = E, a.exports.__esModule = !0, a.exports.default = a.exports;
            }
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/typeof.js": (
            /*!*******************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/typeof.js ***!
              \*******************************************************/
            /***/
            (a) => {
              function u(i) {
                "@babel/helpers - typeof";
                return a.exports = u = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(f) {
                  return typeof f;
                } : function(f) {
                  return f && typeof Symbol == "function" && f.constructor === Symbol && f !== Symbol.prototype ? "symbol" : typeof f;
                }, a.exports.__esModule = !0, a.exports.default = a.exports, u(i);
              }
              a.exports = u, a.exports.__esModule = !0, a.exports.default = a.exports;
            }
          ),
          /***/
          "./node_modules/@babel/runtime/regenerator/index.js": (
            /*!**********************************************************!*\
              !*** ./node_modules/@babel/runtime/regenerator/index.js ***!
              \**********************************************************/
            /***/
            (a, u, i) => {
              var f = i(
                /*! ../helpers/regeneratorRuntime */
                "./node_modules/@babel/runtime/helpers/regeneratorRuntime.js"
              )();
              a.exports = f;
              try {
                regeneratorRuntime = f;
              } catch {
                typeof globalThis == "object" ? globalThis.regeneratorRuntime = f : Function("r", "regeneratorRuntime = r")(f);
              }
            }
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js": (
            /*!*********************************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js ***!
              \*********************************************************************/
            /***/
            (a, u, i) => {
              i.r(u), i.d(u, {
                /* harmony export */
                default: () => (
                  /* binding */
                  f
                )
                /* harmony export */
              });
              function f(E, l) {
                (l == null || l > E.length) && (l = E.length);
                for (var O = 0, m = new Array(l); O < l; O++)
                  m[O] = E[O];
                return m;
              }
            }
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js": (
            /*!*******************************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js ***!
              \*******************************************************************/
            /***/
            (a, u, i) => {
              i.r(u), i.d(u, {
                /* harmony export */
                default: () => (
                  /* binding */
                  f
                )
                /* harmony export */
              });
              function f(E) {
                if (Array.isArray(E))
                  return E;
              }
            }
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js": (
            /*!*********************************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js ***!
              \*********************************************************************/
            /***/
            (a, u, i) => {
              i.r(u), i.d(u, {
                /* harmony export */
                default: () => (
                  /* binding */
                  E
                )
                /* harmony export */
              });
              function f(l, O, m, j, g, L, b) {
                try {
                  var v = l[L](b), c = v.value;
                } catch (y) {
                  m(y);
                  return;
                }
                v.done ? O(c) : Promise.resolve(c).then(j, g);
              }
              function E(l) {
                return function() {
                  var O = this, m = arguments;
                  return new Promise(function(j, g) {
                    var L = l.apply(O, m);
                    function b(c) {
                      f(L, j, g, b, v, "next", c);
                    }
                    function v(c) {
                      f(L, j, g, b, v, "throw", c);
                    }
                    b(void 0);
                  });
                };
              }
            }
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/esm/defineProperty.js": (
            /*!*******************************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/esm/defineProperty.js ***!
              \*******************************************************************/
            /***/
            (a, u, i) => {
              i.r(u), i.d(u, {
                /* harmony export */
                default: () => (
                  /* binding */
                  E
                )
                /* harmony export */
              });
              var f = i(
                /*! ./toPropertyKey.js */
                "./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js"
              );
              function E(l, O, m) {
                return O = (0, f.default)(O), O in l ? Object.defineProperty(l, O, {
                  value: m,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0
                }) : l[O] = m, l;
              }
            }
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js": (
            /*!*************************************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js ***!
              \*************************************************************************/
            /***/
            (a, u, i) => {
              i.r(u), i.d(u, {
                /* harmony export */
                default: () => (
                  /* binding */
                  f
                )
                /* harmony export */
              });
              function f(E, l) {
                var O = E == null ? null : typeof Symbol < "u" && E[Symbol.iterator] || E["@@iterator"];
                if (O != null) {
                  var m, j, g, L, b = [], v = !0, c = !1;
                  try {
                    if (g = (O = O.call(E)).next, l === 0) {
                      if (Object(O) !== O)
                        return;
                      v = !1;
                    } else
                      for (; !(v = (m = g.call(O)).done) && (b.push(m.value), b.length !== l); v = !0)
                        ;
                  } catch (y) {
                    c = !0, j = y;
                  } finally {
                    try {
                      if (!v && O.return != null && (L = O.return(), Object(L) !== L))
                        return;
                    } finally {
                      if (c)
                        throw j;
                    }
                  }
                  return b;
                }
              }
            }
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js": (
            /*!********************************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js ***!
              \********************************************************************/
            /***/
            (a, u, i) => {
              i.r(u), i.d(u, {
                /* harmony export */
                default: () => (
                  /* binding */
                  f
                )
                /* harmony export */
              });
              function f() {
                throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
            }
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js": (
            /*!******************************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js ***!
              \******************************************************************/
            /***/
            (a, u, i) => {
              i.r(u), i.d(u, {
                /* harmony export */
                default: () => (
                  /* binding */
                  m
                )
                /* harmony export */
              });
              var f = i(
                /*! ./arrayWithHoles.js */
                "./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js"
              ), E = i(
                /*! ./iterableToArrayLimit.js */
                "./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js"
              ), l = i(
                /*! ./unsupportedIterableToArray.js */
                "./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js"
              ), O = i(
                /*! ./nonIterableRest.js */
                "./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js"
              );
              function m(j, g) {
                return (0, f.default)(j) || (0, E.default)(j, g) || (0, l.default)(j, g) || (0, O.default)();
              }
            }
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/esm/toPrimitive.js": (
            /*!****************************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js ***!
              \****************************************************************/
            /***/
            (a, u, i) => {
              i.r(u), i.d(u, {
                /* harmony export */
                default: () => (
                  /* binding */
                  E
                )
                /* harmony export */
              });
              var f = i(
                /*! ./typeof.js */
                "./node_modules/@babel/runtime/helpers/esm/typeof.js"
              );
              function E(l, O) {
                if ((0, f.default)(l) !== "object" || l === null)
                  return l;
                var m = l[Symbol.toPrimitive];
                if (m !== void 0) {
                  var j = m.call(l, O || "default");
                  if ((0, f.default)(j) !== "object")
                    return j;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (O === "string" ? String : Number)(l);
              }
            }
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js": (
            /*!******************************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js ***!
              \******************************************************************/
            /***/
            (a, u, i) => {
              i.r(u), i.d(u, {
                /* harmony export */
                default: () => (
                  /* binding */
                  l
                )
                /* harmony export */
              });
              var f = i(
                /*! ./typeof.js */
                "./node_modules/@babel/runtime/helpers/esm/typeof.js"
              ), E = i(
                /*! ./toPrimitive.js */
                "./node_modules/@babel/runtime/helpers/esm/toPrimitive.js"
              );
              function l(O) {
                var m = (0, E.default)(O, "string");
                return (0, f.default)(m) === "symbol" ? m : String(m);
              }
            }
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/esm/typeof.js": (
            /*!***********************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/esm/typeof.js ***!
              \***********************************************************/
            /***/
            (a, u, i) => {
              i.r(u), i.d(u, {
                /* harmony export */
                default: () => (
                  /* binding */
                  f
                )
                /* harmony export */
              });
              function f(E) {
                "@babel/helpers - typeof";
                return f = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(l) {
                  return typeof l;
                } : function(l) {
                  return l && typeof Symbol == "function" && l.constructor === Symbol && l !== Symbol.prototype ? "symbol" : typeof l;
                }, f(E);
              }
            }
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js": (
            /*!*******************************************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js ***!
              \*******************************************************************************/
            /***/
            (a, u, i) => {
              i.r(u), i.d(u, {
                /* harmony export */
                default: () => (
                  /* binding */
                  E
                )
                /* harmony export */
              });
              var f = i(
                /*! ./arrayLikeToArray.js */
                "./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js"
              );
              function E(l, O) {
                if (l) {
                  if (typeof l == "string")
                    return (0, f.default)(l, O);
                  var m = Object.prototype.toString.call(l).slice(8, -1);
                  if (m === "Object" && l.constructor && (m = l.constructor.name), m === "Map" || m === "Set")
                    return Array.from(l);
                  if (m === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(m))
                    return (0, f.default)(l, O);
                }
              }
            }
          )
          /******/
        }, B = {};
        function M(a) {
          var u = B[a];
          if (u !== void 0)
            return u.exports;
          var i = B[a] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return U[a](i, i.exports, M), i.exports;
        }
        M.n = (a) => {
          var u = a && a.__esModule ? (
            /******/
            () => a.default
          ) : (
            /******/
            () => a
          );
          return M.d(u, { a: u }), u;
        }, M.d = (a, u) => {
          for (var i in u)
            M.o(u, i) && !M.o(a, i) && Object.defineProperty(a, i, { enumerable: !0, get: u[i] });
        }, M.o = (a, u) => Object.prototype.hasOwnProperty.call(a, u), M.r = (a) => {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(a, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(a, "__esModule", { value: !0 });
        };
        var X = {};
        return (() => {
          /*!**********************!*\
            !*** ./src/index.js ***!
            \**********************/
          M.r(X), M.d(X, {
            /* harmony export */
            EditorContextHelper: () => (
              /* reexport safe */
              a.EditorContextHelper
            ),
            /* harmony export */
            LoggerService: () => (
              /* reexport safe */
              a.LoggerService
            ),
            /* harmony export */
            PageEditorBridge: () => (
              /* reexport safe */
              a.PageEditorBridge
            ),
            /* harmony export */
            PersonalizationService: () => (
              /* reexport safe */
              a.PersonalizationService
            ),
            /* harmony export */
            TemplateAnnotations: () => (
              /* reexport safe */
              a.TemplateAnnotations
            )
            /* harmony export */
          });
          var a = M(
            /*! ./service */
            "./src/service/index.js"
          );
        })(), X;
      })()
    ));
  }(le)), le.exports;
}
process.env.NODE_ENV === "production" ? ce.exports = Ce() : ce.exports = Te();
var z = ce.exports;
const fe = "mgnl:template", Le = (p, V) => {
  const U = p.__vccOpts || p;
  for (const [B, M] of V)
    U[B] = M;
  return U;
}, xe = {
  name: "DefaultFallbackComponent",
  props: {
    metadata: { type: Object },
    data: { type: Object }
  },
  computed: {
    templateId() {
      return this.metadata[fe];
    }
  },
  methods: {
    trimIfObject(p) {
      return p === "[object Object]" ? "[object]" : p;
    },
    formatValue(p) {
      return this.trimIfObject("" + p);
    }
  }
}, Me = /* @__PURE__ */ te("p", null, null, -1);
function Re(p, V, U, B, M, X) {
  return ie(), ae("div", null, [
    te("div", null, [
      te("strong", null, [
        te("em", null, "Template not found: " + se(X.templateId), 1)
      ])
    ]),
    (ie(!0), ae(Pe, null, Ae(U.data, (a, u) => (ie(), ae("div", { key: u }, se(u) + ": " + se(X.formatValue(a)), 1))), 128)),
    Me
  ]);
}
const be = /* @__PURE__ */ Le(xe, [["render", Re]]), oe = (p, V, U) => {
  p && (p.parentNode.insertBefore(document.createComment(V), p), p.parentNode.insertBefore(document.createComment(U), p.nextSibling));
};
function he(p) {
  p && p.nodeType === 8 && p.remove();
}
const we = (p) => {
  p && (he(p.previousSibling), he(p.nextSibling));
}, re = (p) => p["@name"], Ee = (p, V, U) => {
  if (!p || typeof p != "object")
    return {};
  const B = {};
  let M;
  return U ? (B.data = {}, M = B.data) : M = B, B.metadata = { "@index": V }, B.key = re(p), Object.keys(p).forEach((X) => {
    X.match(/^(@|mgnl:|jcr:)/) ? B.metadata[X] = p[X] : M[X.replace("-", "_")] = p[X];
  }), B;
}, _e = (p, V, U, B, M) => {
  if (!p) {
    const E = "Component content is missing";
    return z.LoggerService.error(E), null;
  }
  if (!V) {
    const E = "Component mappings is missing";
    return z.LoggerService.error(E), null;
  }
  let a = V[p[fe]], u = !1;
  if (!a) {
    const E = `Component with ID ${p[fe]} is not mapped.`;
    z.LoggerService.error(E);
    const l = Ie(U);
    if (!l)
      return null;
    a = l, u = !0;
  }
  const i = Ee(p, M, u), f = Oe(a) ? Se(a) : a;
  return ee(f, i, B);
};
function Ie(p) {
  const V = typeof p == "function" ? p() : p;
  return V != null && typeof V != "boolean" ? V : V ? be : null;
}
const pe = (p, V, U, B, M = 0) => _e(
  p,
  V,
  U,
  B,
  M
), Ue = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  buildKey: re,
  getComponentProperties: Ee,
  getRenderedComponent: _e,
  insertComments: oe,
  mgnlRender: pe,
  removeComments: we
}, Symbol.toStringTag, { value: "Module" })), ne = z.PersonalizationService;
function De() {
  return z.EditorContextHelper.inEditorAsync();
}
function Be() {
  return z.EditorContextHelper.inEditorPreview();
}
function Ve() {
  return z.EditorContextHelper.isRenderingAnnotation();
}
function We() {
  return z.EditorContextHelper.inIframe();
}
function Ne() {
  return z.EditorContextHelper.isSameOrigin();
}
function Ke(p) {
  z.EditorContextHelper.refresh(p);
}
function Fe(p) {
  z.EditorContextHelper.setServerUrl(p);
}
function Ge() {
  return z.EditorContextHelper.isPageEditorReady();
}
function He() {
  z.EditorContextHelper.onFrameReady();
}
function $e() {
  return z.EditorContextHelper.inPreviewAsVisitor();
}
function ze(p, V, U) {
  return z.EditorContextHelper.getMagnoliaContext(p, V, U);
}
const q = {
  inIframe: We,
  isSameOrigin: Ne,
  refresh: Ke,
  setServerUrl: Fe,
  isPageEditorReady: Ge,
  onFrameReady: He,
  inPreviewAsVisitor: $e,
  inEditorAsync: De,
  inEditorPreview: Be,
  isRenderingAnnotation: Ve,
  getMagnoliaContext: ze
}, Je = {
  name: "EditablePage",
  props: {
    content: { type: Object },
    config: {
      type: Object,
      required: !0
    },
    templateAnnotations: { type: Object }
  },
  setup(p) {
    let V = {};
    return p.templateAnnotations && (V = je({ value: p.templateAnnotations })), {
      reactiveTemplateAnnotations: V
    };
  },
  data() {
    return {
      selectedComponentVariants: "",
      listeners: {}
    };
  },
  computed: {
    renderingContent() {
      const p = z.TemplateAnnotations.generateMissingAreas(
        this.content,
        this.reactiveTemplateAnnotations.value
      );
      return ne.getVariant(
        p,
        this.reactiveTemplateAnnotations.value
      );
    }
  },
  methods: {
    writeAnnotation() {
      if (this.content && this.reactiveTemplateAnnotations.value && this.reactiveTemplateAnnotations.value[this.renderingContent["@path"]]) {
        we(this.$el);
        const p = this.reactiveTemplateAnnotations.value[this.renderingContent["@path"]];
        oe(this.$el, p, "/cms:page"), q.onFrameReady(), q.refresh();
      }
    },
    updateTemplateAnnotationsProvider() {
      this.reactiveTemplateAnnotations.value = ne.wrap(
        this.templateAnnotations,
        this.selectedComponentVariants
      );
    }
  },
  provide() {
    return {
      config: this.config,
      templateAnnotations: this.reactiveTemplateAnnotations
    };
  },
  mounted() {
    q.inIframe() && (z.PageEditorBridge.onMessage(this.listeners, "updateState", (p) => {
      this.selectedComponentVariants = p.selectedComponentVariants, this.updateTemplateAnnotationsProvider();
    }), z.PageEditorBridge.init(this.listeners), this.writeAnnotation());
  },
  beforeUpdate() {
    q.inIframe() && (this.updateTemplateAnnotationsProvider(), this.writeAnnotation());
  },
  render() {
    return pe(
      this.renderingContent,
      this.config.componentMappings,
      this.config.fallbackComponent
    );
  }
}, Xe = Je, Ye = {
  name: "EditableComponent",
  inject: ["config", "templateAnnotations"],
  props: ["content", "index"],
  computed: {
    renderingContent() {
      return z.TemplateAnnotations.generateMissingAreas(
        this.personalizedContent,
        this.templateAnnotations.value
      );
    }
  },
  data() {
    return {
      personalizedContent: this.content
    };
  },
  methods: {
    writeAnnotation() {
      if (this.content && this.templateAnnotations.value && this.templateAnnotations.value[this.renderingContent["@path"]]) {
        const p = this.templateAnnotations.value[this.renderingContent["@path"]];
        oe(this.$el, p, "/cms:component"), q.refresh();
      }
    }
  },
  async mounted() {
    q.inEditorAsync().then((p) => {
      p && this.writeAnnotation(), this.personalizedContent = ne.getVariant(
        this.content,
        this.templateAnnotations.value
      );
    });
  },
  render() {
    return pe(
      this.renderingContent,
      this.config.componentMappings,
      this.config.fallbackComponent,
      {},
      this.index
    );
  }
}, de = Ye, ke = {
  name: "EditableArea",
  components: {
    EditableComponent: de
  },
  inject: ["config", "templateAnnotations"],
  props: {
    content: {
      type: Object
    },
    parentTemplateId: {
      type: String,
      required: !1
    },
    elementType: {
      type: String,
      default: "div"
    },
    customView: {
      type: Object
    }
  },
  methods: {
    writeAnnotation() {
      if (this.content && this.templateAnnotations.value && this.templateAnnotations.value[this.content["@path"]]) {
        const p = this.templateAnnotations.value[this.content["@path"]];
        oe(this.$el, p, "/cms:area"), q.refresh();
      }
    }
  },
  async mounted() {
    await q.inEditorAsync() && this.writeAnnotation();
  },
  render() {
    if (!this.content)
      return null;
    const p = this.content["@nodes"].map((U) => this.content[U]);
    let V = [];
    return this.$slots.default ? ee(this.elementType, null, this.$slots.default({ content: this.content })) : (V = p.map(
      (U, B) => ee(de, { content: U, key: re(U), index: B }, null)
    ), ee(
      this.elementType,
      null,
      this.customView ? ee(this.customView, {
        content: this.content,
        key: re(this.content)
      }) : V
    ));
  }
}, Qe = ke, ge = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DefaultFallbackComponent: be,
  EditableArea: Qe,
  EditableComponent: de,
  EditablePage: Xe,
  EditorContextHelper: q,
  PersonalizationService: ne,
  helper: Ue
}, Symbol.toStringTag, { value: "Module" })), Ze = {
  install(p) {
    (Object.keys(ge) || []).forEach((U) => {
      if (U !== "helper" && U !== "EditableMixin") {
        const B = ge[U];
        p.component(B.name, B);
      }
    });
  }
};
typeof window < "u" && window.Vue && window.Vue.use(Ze);
export {
  be as DefaultFallbackComponent,
  Qe as EditableArea,
  de as EditableComponent,
  Xe as EditablePage,
  q as EditorContextHelper,
  ne as PersonalizationService,
  Ze as default,
  Ue as helper
};
//# sourceMappingURL=vue-editor.es.js.map
